import { queryClient } from "../query-client/query-client";

import {
  isServer,
  QueryClient,
  QueryClientConfig,
} from "@tanstack/react-query";

export type CreateQueryClientOutput = QueryClient;

let browserQueryClient: QueryClient | undefined;

export const getQueryClient = () => {
  if (isServer) return createQueryClient();

  if (!browserQueryClient) browserQueryClient = queryClient;

  return browserQueryClient;
};

export const createQueryClient = (
  config?: QueryClientConfig
): CreateQueryClientOutput => {
  return new QueryClient(config);
};

export default createQueryClient;
